import { PlusIcon } from "./Icons.js";

export function EmptyState({ onAdd }: { onAdd: () => void }) {
  return (
    <div className="empty-state">
      <div className="empty-state__art" aria-hidden>
        <svg width="120" height="80" viewBox="0 0 120 80" fill="none">
          <polyline
            points="4,64 24,48 44,54 64,28 84,36 116,8"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.9"
          />
          <rect x="20" y="60" width="6" height="14" rx="1" fill="currentColor" opacity="0.25" />
          <rect x="40" y="56" width="6" height="18" rx="1" fill="currentColor" opacity="0.25" />
          <rect x="60" y="44" width="6" height="30" rx="1" fill="currentColor" opacity="0.25" />
          <rect x="80" y="50" width="6" height="24" rx="1" fill="currentColor" opacity="0.25" />
        </svg>
      </div>
      <h2>Build your chart wall</h2>
      <p>
        Add any US stock or ETF, or drag across the grid to choose its exact
        size and position.
      </p>
      <button type="button" className="button button--primary" onClick={onAdd}>
        <PlusIcon />
        <span>Add your first chart</span>
      </button>
    </div>
  );
}
